import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  /* height: 100vh; */
  padding: 0;
  margin: 0;

  .btn-print {
    position: fixed;
    bottom: 20px;
    left: 20px;
    border-radius: 5px;
    box-shadow: 2px 2px 2px 2px gray;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
`;

export const FactorStyle = styled.div`
  width: 600px;
  border: 1px solid black;
  padding: 1rem 0 0 0;
`;

export const HeaderFactor = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContactStyle = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
`;

export const ContentContact = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  border: 1px solid #000;
  width: 100%;
  height: 1px;
  position: relative;
  margin-top: 1rem;
`;

export const Title = styled.p`
  margin: 0 auto;
  background-color: #ccc;
  width: 15%;
  font-size: 10px;
  text-align: center;
  border-radius: 5px;
  border: 1px solid #000;
  position: absolute;
  left: 44%;
  top: -10px;
`;

export const MainContentContact = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 0.5rem;
`;

export const NumberFactor = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 1rem;
  padding-right: 1rem;
  border-right: 1px solid #000;
`;

export const ContentSeller = styled.div`
  display: flex;
  flex-direction: column;
`;

export const InfoStyle = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  padding: 0.5rem;
`;

export const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  p {
    width: 50%;
  }
`;

export const Table = styled.table`
  border-bottom: 1px solid #000;
  /* border-collapse: collapse; */
`;

export const Tr = styled.tr`
  font-size: 14px;
  background-color: #cccccc;
  text-align: center;
  border: 1px solid #ddd;

  td {
    padding: 0.5rem 0;
    border: 1px solid gray;
    font-size: 12px;
    /* border: 1px solid #000;  */
  }
  .diff {
    background-color: #fff;

    /* padding: 0.5rem 0; */
  }

  .desc {
    background-color: #fff;
    text-align: right !important;
  }
  &:nth-child(even) {
    background-color: #bcffa2;
  }

  .demo {
    background-color: #cccccc;
  }
`;

export const Description = styled.div`
  display: flex;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: ${({ bottom }) => (bottom ? "" : "1px solid #000")};
  border-top: ${({ top }) => (top ? "1px solid #000" : null)};
  padding: 0.5rem;
`;

export const CardTitle = styled.div`
  display: flex;
  justify-content: space-around;
  padding: 1.5rem;
`;
